import dragButton from "../../../assets/img/TicketCard/dragButton.svg";
import { Draggable } from "react-beautiful-dnd";

const IndividualTagComponent = ({
	tagData,
	index,
	tagText,
	editIcon,
	editClickHandler,
	deleteIcon,
	deleteClickHandler,
	isDragDisabled = false
}) => {
	return (
		<>
			<Draggable
				key={String(tagData?.id)}
				draggableId={String(tagData?.id)}
				index={index}
				isDragDisabled={isDragDisabled}
			>
				{provided => (
					<div ref={provided.innerRef} {...provided.draggableProps} className="my-1">
						<span className="tag-border">
							{!isDragDisabled && (
								<span className="ml-2">
									<img
										{...provided.dragHandleProps}
										className="text-center dragCus"
										src={dragButton}
									/>
								</span>
							)}
							<span className="pr-2 ml-2">{tagText}</span>
							<span className="tag-divider pr-2">|</span>
							{editIcon && (
								<span className="pr-2">
									<i
										style={{
											fontSize: "14px",
											transform: "translateY(2px)"
										}}
										onClick={editClickHandler}
										className="iconSize fas fa-pen"
									></i>
								</span>
							)}
							{deleteIcon && (
								<span className="pr-2 deleteIconStyles">
									<i
										style={{ color: "rgb(87, 33, 72)", fontSize: "14px" }}
										className="fas fa-trash text-danger"
										onClick={deleteClickHandler}
									></i>
								</span>
							)}
						</span>
					</div>
				)}
			</Draggable>
			<style>
				{`
					.tag-border{
						color: #572148;
						font-size: 14px;
						font-weight: 400;
						border: 1px solid #572148;
						border-radius: 2px;
						margin-right: 10px;
					}
					.tag-divider{
						color: #572148;
					}
					.deleteIconStyles{
						vertical-align: middle;
						display: inline-flex;
					}
					.dragCus {
						color: rgb(87, 33, 72);
						width: 6.3px;
						margin: 2px;
					}
				`}
			</style>
		</>
	);
};

export default IndividualTagComponent;
